import { render, staticRenderFns } from "./FeedbackListing.vue?vue&type=template&id=5812e012&"
import script from "./FeedbackListing.vue?vue&type=script&lang=js&"
export * from "./FeedbackListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports